// One visual contract for the board, RO dialogs and workflow settings preview.
const stateColors = (role) => ({
  background: `{${role}.color}`,
  color: `{${role}.contrast.color}`,
  hoverBackground: `{${role}.hover.color}`,
  hoverColor: `var(--p-${role}-hover-contrast-color, {${role}.contrast.color})`,
});

export const bayhiveWorkflowTokens = {
  arrowDepth: '0.75rem',
  separatorWidth: '0.125rem',
  rowGap: '0.375rem',
  minHeight: '2rem',
  fontSize: '0.75rem',
  lineHeight: '1rem',
  paddingX: '0.75rem',
  paddingY: '0.25rem',
  linkGap: '0.25rem',
  active: stateColors('primary'),
  success: stateColors('success'),
  warning: stateColors('warn'),
  danger: stateColors('danger'),
};

export const bayhiveWorkflowLight = {
  upcomingBackground: '{neutral.300}',
  completedBackground: 'color-mix(in srgb, {purple.400} 22%, {neutral.100})',
  textColor: '#000000',
  separatorColor: '{neutral.600}',
  linkBaseWeight: '88%',
  shadeColor: '{neutral.950}',
};

export const bayhiveWorkflowDark = {
  upcomingBackground: '{surface.600}',
  completedBackground: 'color-mix(in srgb, {purple.400} 50%, {neutral.600})',
  textColor: '{surface.0}',
  separatorColor: '{neutral.300}',
  linkBaseWeight: '65%',
  shadeColor: '{neutral.950}',
};
